import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Typography,
    Box,
    CircularProgress
} from '@mui/material';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { Apiurl } from '../api_urls';
import { GToaster } from './g_toaster';
const toster = new GToaster()
const ForgotPasswordModal = ({ open, onClose, usertype }) => {
    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting },
        reset,
    } = useForm();

    const handleFormSubmit = async (data) => {
        await axios.get(`${Apiurl.FORGOT_PASSWORD_URL}${usertype}/${data?.email}`).then((response) => {
            if (response.status === 200) {
                if (response.data?.status === 200) {
                    toster.success({ title: "Password send to your registered email Successfully" });
                } else {
                    toster.error({ title: response?.data?.message });
                }
            } else {
                toster.error({ title: response?.data?.message });
            }
        }).catch((err) => {
            toster.error({ title: err?.data?.message });
        })
        reset();
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>
                <Typography variant="h6">Forgot Password</Typography>
            </DialogTitle>

            <DialogContent>
                <Box
                    component="form"
                    onSubmit={handleSubmit(handleFormSubmit)}
                    id="forgot-password-form"
                >
                    <TextField
                        label="Registered Email"
                        type="email"
                        size="small"
                        fullWidth
                        margin="normal"
                        {...register('email', {
                            required: 'Email is required',
                            pattern: {
                                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                message: 'Invalid email address',
                            },
                        })}
                        error={!!errors.email}
                        helperText={errors.email?.message}
                    />
                </Box>
            </DialogContent>

            <DialogActions sx={{ px: 3, pb: 2, display: 'flex', justifyContent: 'space-between' }}>
                <Button onClick={onClose} color="secondary" variant="contained">
                    Cancel
                </Button>
                <Button
                    type="submit"
                    form="forgot-password-form"
                    variant="contained"
                    color="primary"
                    disabled={isSubmitting}
                    startIcon={
                        isSubmitting ? <CircularProgress size={20} color="inherit" /> : null
                    }
                >
                    {isSubmitting ? 'Sending...' : 'Send Reset Link'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ForgotPasswordModal;
